import * as aos from 'aos';

aos.init();

const el = document.querySelector('.jumbotron-background') as HTMLElement;

window.addEventListener('scroll', () => {
  el.style.backgroundPositionY = -1 * Math.round(window.scrollY / 2) + 'px';
}, { passive: true });
